export enum EnvironmentType
{
    Staging='Staging',
    Demo='Demo',
    Production = 'Production'
}
